import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiLeaguesService } from '../../../../services/leagues/api/api-leagues.service';
import { AlertsService } from '../../../../services/alerts.service';
import { LeagueDivisionUser } from '../../../../models/leagues/league-division-user.model';

@Component({
  selector: 'app-league-division-users-modal',
  templateUrl: './league-division-users-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, RouterModule]
})
export class LeagueDivisionUsersModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  divisionId: number = 0;
  users: LeagueDivisionUser[] = [];

  constructor(private apiLeaguesService: ApiLeaguesService, private alertsService: AlertsService) {}

  getDisplayName(user: LeagueDivisionUser): string {
    return user.userDisplayname ? user.userDisplayname : `Guest${user.userId}`;
  }

  show(divisionId: number): void {
    this.divisionId = divisionId;
    this.users = [];
    this.isLoading = false;
    this.modal.show();
    this.refreshUsers();
  }

  private refreshUsers(): void {
    this.isLoading = true;
    this.apiLeaguesService.getLeagueDivisionUsers(this.divisionId).then(
      response => {
        this.isLoading = false;
        this.users = response.results;
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error loading division users : ' + error);
      }
    );
  }
}
